__webpack_require__.p =(function(defaultPublicPath, publicPaths, environmentType) {
                        let publicPath = '';
                        const documentSrc = document?.currentScript?.src ?? script?.src;
                        if (documentSrc) {
                            try {
                                const url = new URL(documentSrc);
                                publicPath = url.origin + url.pathname.split('/').slice(0,-1).join('/');
                            } catch(e) {
                                console.error(e);
                            }
                        } else {
                            if (!environmentType) {
                                environmentType = 'TENANT';
                            }
                            const environmentCode = window?.sirius?.shared?.environment?.getCode(environmentType);
                            if (environmentCode && publicPaths?.hasOwnProperty(environmentCode)) {
                                publicPath = publicPaths?.[environmentCode] ?? '';
                            }
                        }
                        if (!publicPath) {
                            publicPath = self.location.origin + self.location.pathname.split('/').slice(0,-1).join('/');
                        }
                        if (!publicPath) {
                            publicPath = defaultPublicPath;
                        }
                        return publicPath + (publicPath?.endsWith('/') ? '' : '/');
                    })('', {}, 'TENANT');